window.updateQuantityButtonsState = (wrapper) => {
  if (!wrapper) return;
  const input = wrapper.querySelector('input[name="quantity"], input[name^="updates"]');
  if (!input) return;

  const min = Number(input.min || 1);
  const hasMaxAttr = input.hasAttribute('max') && input.getAttribute('max') !== '';
  const max = hasMaxAttr ? Number(input.getAttribute('max')) : Infinity;
  const current = Number(input.value || min);

  const increaseBtn = wrapper.querySelector('[data-quantity-toggle="increase"]');
  const decreaseBtn = wrapper.querySelector('[data-quantity-toggle="decrease"]');

  if (increaseBtn) {
    const isAtMax = hasMaxAttr && current >= max;
    increaseBtn.disabled = isAtMax;
    increaseBtn.setAttribute('aria-disabled', String(isAtMax));
    increaseBtn.classList.toggle('is-disabled', isAtMax);
  }

  if (decreaseBtn) {
    const isAtMin = current <= min;
    decreaseBtn.disabled = isAtMin;
    decreaseBtn.setAttribute('aria-disabled', String(isAtMin));
    decreaseBtn.classList.toggle('is-disabled', isAtMin);
  }
};

document.addEventListener('click', (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;
  const toggle = event.target.closest('[data-quantity-toggle]');
  if (!toggle) return;

  if (toggle.disabled || toggle.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  const wrapper = toggle.closest('[data-quantity-selector]');
  const input = wrapper?.querySelector('input[name="quantity"], input[name^="updates"]');
  if (!input) return;

  const min = Number(input.min || 1);
  const hasMaxAttr = input.hasAttribute('max') && input.getAttribute('max') !== '';
  const max = hasMaxAttr ? Number(input.getAttribute('max')) : 999;
  const current = Number(input.value || min);
  const next = toggle.dataset.quantityToggle === 'increase' ? current + 1 : current - 1;

  input.value = Math.max(min, Math.min(max, next));
  input.dispatchEvent(new Event('change', { bubbles: true }));
  window.updateQuantityButtonsState(wrapper);
});

let cartUpdateTimer = null;
const FREE_SHIPPING_PRICE_THRESHOLD = 69900;

document.addEventListener('change', (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;

  const qtyInput = event.target.closest('input[name="quantity"], input[name^="updates"]');
  if (qtyInput) {
    const wrapper = qtyInput.closest('[data-quantity-selector]');
    const min = Number(qtyInput.min || 1);
    const hasMaxAttr = qtyInput.hasAttribute('max') && qtyInput.getAttribute('max') !== '';
    const max = hasMaxAttr ? Number(qtyInput.getAttribute('max')) : 999;
    const val = parseInt(qtyInput.value, 10);
    if (isNaN(val) || val < min) {
      qtyInput.value = min;
    } else if (val > max) {
      qtyInput.value = max;
    }
    if (wrapper) window.updateQuantityButtonsState(wrapper);
    if (qtyInput.name === 'quantity') return;
  }

  const input = event.target.closest('.gyc-cart-layout input[name^="updates"]');
  if (!input) return;

  const form = input.closest('.gyc-cart-layout');
  const updateButton = form?.querySelector('button[name="update"]');
  if (!form || form.dataset.cartUpdating === 'true') return;

  window.clearTimeout(cartUpdateTimer);
  cartUpdateTimer = window.setTimeout(() => {
    form.dataset.cartUpdating = 'true';
    form.setAttribute('aria-busy', 'true');
    if (updateButton) {
      form.requestSubmit(updateButton);
    } else {
      form.requestSubmit();
    }
  }, 450);
});

document.addEventListener('submit', (event) => {
  const form = event.target?.closest?.('.gyc-cart-layout');
  if (!form) return;

  const submitter = event.submitter || document.activeElement;
  if (submitter && submitter.name === 'checkout') {
    const minOrderCents = Number(form.dataset.minOrderCents || 10000);
    const cartTotalPrice = Number(form.dataset.cartTotalPrice || 0);

    if (cartTotalPrice > 0 && cartTotalPrice < minOrderCents) {
      event.preventDefault();
      event.stopPropagation();
      const isArabic = String(document.documentElement.lang || '').toLowerCase().startsWith('ar');
      const formattedMin = (minOrderCents / 100).toFixed(0);
      alert(isArabic ? `الحد الأدنى للطلب هو ${formattedMin} جنيه.` : `Minimum order amount is EGP ${formattedMin}.`);
    }
  }
});

const fetchCart = async () => {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return null;
    return await res.json();
  } catch (_) {
    return null;
  }
};

const showCartProgressToast = () => {};

const refreshHeaderCartCount = async () => {
  try {
    const cart = await fetchCart();
    if (!cart) return null;
    const cartIcons = document.querySelectorAll('.gyc-header__icon--cart');
    cartIcons.forEach((icon) => {
      let countEl = icon.querySelector('.gyc-header__count');

      if (cart.item_count > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'gyc-header__count';
          icon.appendChild(countEl);
        }
        countEl.textContent = String(cart.item_count);
      } else if (countEl) {
        countEl.remove();
      }
    });

    const bottomCart = document.querySelector('.gyc-bottom-nav__cart');
    if (!bottomCart) return;

    let countEl = bottomCart.querySelector('.gyc-bottom-nav__count');
    if (cart.item_count > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'gyc-bottom-nav__count';
        bottomCart.appendChild(countEl);
      }
      countEl.textContent = String(cart.item_count);
    } else if (countEl) {
      countEl.remove();
    }
    return cart;
  } catch (_) {
    return null;
  }
};

document.addEventListener('submit', async (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;
  const form = event.target.closest('#product-form, .gyc-quick-add-form');
  if (!form) return;

  const submitter = event.submitter;
  if (submitter && submitter.name && submitter.name !== 'add') return;

  event.preventDefault();

  if (form.dataset.addToCartPending === 'true') return;
  form.dataset.addToCartPending = 'true';

  const button = submitter || form.querySelector('button[name="add"], button[type="submit"]');
  const textNode = button?.querySelector('[data-add-to-cart-text]');
  const quickIcon = button?.querySelector('[data-quick-add-icon]');
  const i18n = form.querySelector('[data-cart-i18n], [data-money-config]');
  const originalText = textNode ? textNode.textContent : button?.textContent;
  const originalDisabled = Boolean(button?.disabled);

  if (button) {
    button.disabled = true;
    button.classList.remove('is-added');
    button.classList.add('is-loading');
  }

  try {
    const qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput && qtyInput.hasAttribute('max') && qtyInput.getAttribute('max') !== '') {
      const maxQty = Number(qtyInput.getAttribute('max'));
      if (Number(qtyInput.value) > maxQty) {
        qtyInput.value = String(maxQty);
      }
    }

    const cartBeforeAdd = await fetchCart();
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Add to cart failed');

    const cartAfterAdd = await refreshHeaderCartCount();
    showCartProgressToast(cartAfterAdd);
    window.sessionStorage.setItem('gyc_prev_cart_total', String(cartAfterAdd ? cartAfterAdd.total_price : 0));

    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
      return;
    }

    if (textNode) {
      textNode.textContent = i18n?.dataset.added || 'Added';
      window.setTimeout(() => {
        textNode.textContent = originalText || i18n?.dataset.addToCart || 'Add to cart';
      }, 1200);
    } else if (button) {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      if (quickIcon) {
        quickIcon.animate(
          [
            { transform: 'scale(1) rotate(0deg)' },
            { transform: 'scale(1.14) rotate(-8deg)' },
            { transform: 'scale(1) rotate(0deg)' }
          ],
          { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }
        );
      } else {
        button.animate(
          [
            { transform: 'scale(1)' },
            { transform: 'scale(1.08)' },
            { transform: 'scale(1)' }
          ],
          { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }
        );
      }

      window.setTimeout(() => {
        button.classList.remove('is-added');
      }, 1200);
    }
  } catch (_) {
    if (button) button.classList.remove('is-loading');
  } finally {
    delete form.dataset.addToCartPending;
    if (button) {
      button.classList.remove('is-loading');
      button.disabled = originalDisabled;
    }
  }
});

const setupRecentPurchaseToast = () => {};

document.addEventListener('DOMContentLoaded', () => {
  if (typeof setupRecentPurchaseToast === 'function') setupRecentPurchaseToast();
  document.querySelectorAll('[data-quantity-selector]').forEach((el) => {
    if (window.updateQuantityButtonsState) window.updateQuantityButtonsState(el);
  });

  // Initialize Product Recommendations
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection) {
    if (productRecommendationsSection.querySelector('.gyc-product-related:not(.is-loading)')) {
      initializeRecommendationsCarousel(productRecommendationsSection);
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.querySelector('.gyc-product-related:not(.is-loading)')) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            initializeRecommendationsCarousel(productRecommendationsSection);
          } else if (!productRecommendationsSection.querySelector('.gyc-product-related:not(.is-loading)')) {
            productRecommendationsSection.innerHTML = '';
          }
        })
        .catch((e) => {
          console.error('Error loading recommendations:', e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 400px 0px',
    });
    observer.observe(productRecommendationsSection);
  }
});

document.addEventListener('gyc:deferred-widgets-loaded', () => {
  if (typeof setupRecentPurchaseToast === 'function') setupRecentPurchaseToast();
  document.querySelectorAll('[data-quantity-selector]').forEach((el) => {
    if (window.updateQuantityButtonsState) window.updateQuantityButtonsState(el);
  });
});

const initializeRecommendationsCarousel = (container) => {
  const carousel = container.querySelector('.gyc-product-related__carousel');
  const prevBtn = container.querySelector('.gyc-carousel-nav--prev');
  const nextBtn = container.querySelector('.gyc-carousel-nav--next');
  if (!carousel || carousel.dataset.initialized === 'true') return;
  carousel.dataset.initialized = 'true';

  const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  const directionMultiplier = isRTL ? -1 : 1;

  let autoplayTimeout = null;
  let userInteractionTimeout = null;
  let isHoveredOrTouched = false;

  const updateButtons = () => {
    if (!prevBtn || !nextBtn) return;
    const scrollLeft = carousel.scrollLeft;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    prevBtn.disabled = Math.abs(scrollLeft) <= 5;
    nextBtn.disabled = Math.abs(scrollLeft) >= maxScroll - 5;
  };

  const getScrollAmount = () => {
    const card = carousel.firstElementChild;
    const cardWidth = card ? card.clientWidth + parseFloat(getComputedStyle(carousel).gap || '16') : carousel.clientWidth;
    return carousel.clientWidth > 768 ? cardWidth * 2 : cardWidth;
  };

  const scrollNext = () => {
    const scrollAmount = getScrollAmount();
    const currentScroll = Math.abs(carousel.scrollLeft);
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    if (currentScroll >= maxScroll - 10) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: scrollAmount * directionMultiplier, behavior: 'smooth' });
    }
  };

  const scrollPrev = () => {
    const scrollAmount = getScrollAmount();
    const currentScroll = Math.abs(carousel.scrollLeft);
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    if (currentScroll <= 10) {
      carousel.scrollTo({ left: maxScroll * directionMultiplier, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: -scrollAmount * directionMultiplier, behavior: 'smooth' });
    }
  };

  const startAutoplay = () => {
    stopAutoplay();
    if (isHoveredOrTouched) return;
    autoplayTimeout = setTimeout(() => {
      scrollNext();
      startAutoplay();
    }, 3500);
  };

  const stopAutoplay = () => {
    if (autoplayTimeout) {
      clearTimeout(autoplayTimeout);
      autoplayTimeout = null;
    }
  };

  const restartAutoplayAfterDelay = (delay = 4000) => {
    stopAutoplay();
    if (userInteractionTimeout) clearTimeout(userInteractionTimeout);
    userInteractionTimeout = setTimeout(() => {
      startAutoplay();
    }, delay);
  };

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      scrollPrev();
      restartAutoplayAfterDelay(5000);
    });

    nextBtn.addEventListener('click', () => {
      scrollNext();
      restartAutoplayAfterDelay(5000);
    });
  }

  carousel.addEventListener('mouseenter', () => {
    isHoveredOrTouched = true;
    stopAutoplay();
  });

  carousel.addEventListener('mouseleave', () => {
    isHoveredOrTouched = false;
    restartAutoplayAfterDelay(2000);
  });

  carousel.addEventListener('touchstart', () => {
    isHoveredOrTouched = true;
    stopAutoplay();
  }, { passive: true });

  carousel.addEventListener('touchend', () => {
    isHoveredOrTouched = false;
    restartAutoplayAfterDelay(3000);
  }, { passive: true });

  carousel.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons, { passive: true });
  setTimeout(updateButtons, 150);

  if (carousel.scrollWidth > carousel.clientWidth) {
    startAutoplay();
  }
};

// ============================================================
// Quick View Modal
// ============================================================

const gycQuickViewModal = (() => {
  let modal, backdrop, loadingEl, bodyEl, i18nEl;
  let isPending = false;

  const init = () => {
    modal = document.getElementById('gyc-quick-view-modal');
    if (!modal) return;

    backdrop = modal.querySelector('[data-quick-view-backdrop]');
    loadingEl = modal.querySelector('[data-quick-view-loading]');
    bodyEl = modal.querySelector('[data-quick-view-body]');
    i18nEl = modal.querySelector('[data-quick-view-i18n]');

    backdrop?.addEventListener('click', close);
    modal.querySelector('[data-quick-view-close]')?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    bodyEl?.addEventListener('submit', (e) => {
      if (!e.target || typeof e.target.closest !== 'function') return;
      const form = e.target.closest('form.gyc-product-form');
      if (form) {
        e.stopPropagation();
        handleAddToCart(e, form);
      }
    });
  };

  const open = async (productUrl) => {
    if (!modal) return;

    loadingEl.hidden = false;
    bodyEl.hidden = true;
    bodyEl.innerHTML = '';
    modal.hidden = false;

    // Reset scroll position on open to ensure the close button is visible
    const dialog = modal.querySelector('.gyc-quick-view-modal__dialog');
    if (dialog) {
      dialog.scrollTop = 0;
    }

    document.body.classList.add('gyc-quick-view-open');
    requestAnimationFrame(() => modal.classList.add('is-visible'));

    try {
      const response = await fetch(productUrl);
      if (!response.ok) throw new Error('Product load failed');
      const html = await response.text();

      populate(html, productUrl);

      loadingEl.hidden = true;
      bodyEl.hidden = false;
    } catch (err) {
      console.error(err);
      close();
    }
  };

  const close = () => {
    if (!modal) return;
    modal.classList.remove('is-visible');
    document.body.classList.remove('gyc-quick-view-open');
    window.setTimeout(() => { modal.hidden = true; }, 270);
  };

  const populate = (html, productUrl) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const layout = doc.querySelector('.gyc-product-layout');
    const description = doc.querySelector('.gyc-product-description');

    if (!layout) {
      bodyEl.innerHTML = '<p class="error-msg">Product content could not be loaded.</p>';
      return;
    }

    // Strip breadcrumbs, reviews, and judge.me widgets
    layout.querySelectorAll('.breadcrumbs, .gyc-product-reviews, #judgeme_product_reviews, .jdgm-widget, .jdgm-review-widget').forEach(el => el.remove());

    bodyEl.innerHTML = '';
    bodyEl.appendChild(layout);

    if (description) {
      description.querySelectorAll('.gyc-product-reviews, #judgeme_product_reviews, .jdgm-widget, .jdgm-review-widget').forEach(el => el.remove());
      bodyEl.appendChild(description);
    }

    // Re-initialize theme gallery/form actions
    if (window.initializeProductSection) {
      window.initializeProductSection(bodyEl);
    }
  };

  const handleAddToCart = async (e, formElement) => {
    e.preventDefault();
    const idInput = formElement.querySelector('input[name="id"]');
    const addBtn = formElement.querySelector('button[name="add"]');
    const addTextEl = formElement.querySelector('[data-add-to-cart-text]');
    if (!idInput?.value || isPending || addBtn?.disabled) return;

    isPending = true;
    const originalText = addTextEl?.textContent || '';

    if (addBtn) {
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
    }

    try {
      const cartBefore = await fetchCart();
      const formData = new FormData(formElement);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });

      if (!response.ok) throw new Error('Add to cart failed');

      const cartAfter = await refreshHeaderCartCount();
      showCartProgressToast(cartAfter);
      window.sessionStorage.setItem('gyc_prev_cart_total', String(cartAfter ? cartAfter.total_price : 0));

      if (addTextEl) addTextEl.textContent = i18nEl?.dataset.added || 'Added';
      if (addBtn) {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
      }

      if (window.location.pathname.includes('/cart')) {
        window.setTimeout(() => { window.location.reload(); }, 700);
      } else {
        window.setTimeout(() => {
          close();
          window.setTimeout(() => {
            if (addTextEl) addTextEl.textContent = originalText;
            if (addBtn) {
              addBtn.classList.remove('is-added');
              addBtn.disabled = false;
            }
          }, 300);
        }, 900);
      }
    } catch (_) {
      if (addBtn) {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
      }
    } finally {
      isPending = false;
    }
  };

  document.addEventListener('DOMContentLoaded', init);

  return { open, close };
})();

document.addEventListener('click', (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;
  const btn = event.target.closest('[data-quick-view-trigger]');
  if (!btn || btn.disabled) return;
  const url = btn.dataset.productUrl;
  if (!url) return;
  gycQuickViewModal.open(url);
});

// Color marble click → open quick view pre-selected to that color
document.addEventListener('click', (event) => {
  if (!event.target || typeof event.target.closest !== 'function') return;
  const marble = event.target.closest('[data-color-quick-view]');
  if (!marble) return;
  event.stopPropagation();
  const url = marble.dataset.productUrl;
  if (!url) return;
  gycQuickViewModal.open(url);
});



